const connectorActionTypes = {
    

    START_START_TRANSACTION: 'START_START_TRANSACTION',
    START_TRANSACTION_SUCCESS: 'START_TRANSACTION_SUCCESS',
    START_TRANSACTION_FAILURE: 'START_TRANSACTION_FAILURE',

    START_START_SMART_TRANSACTION:   'START_START_SMART_TRANSACTION',
    START_SMART_TRANSACTION_SUCCESS: 'START_SMART_TRANSACTION_SUCCESS',
    START_SMART_TRANSACTION_FAILURE: 'START_SMART_TRANSACTION_FAILURE',

    START_STOP_TRANSACTION: 'START_STOP_TRANSACTION',
    STOP_TRANSACTION_SUCCESS: 'STOP_TRANSACTION_SUCCESS',
    STOP_TRANSACTION_FAILURE: 'STOP_TRANSACTION_FAILURE',

    // spec 000220 — ends the pending start/stop once the live status confirms it (or on timeout / leaving the screen).
    CLEAR_PENDING_CHARGING_ACTION: 'CLEAR_PENDING_CHARGING_ACTION',
    // spec 000220 (Part C) — the connector screen publishes its 000023 waiting window so the title band can agree.
    SET_WAITING_FOR_CHARGING: 'SET_WAITING_FOR_CHARGING',

    START_GET_TRANSACTION_SUMMERY: 'START_GET_TRANSACTION_SUMMERY',
    GET_TRANSACTION_SUMMERY_SUCCESS: 'GET_TRANSACTION_SUMMERY_SUCCESS',
    GET_TRANSACTION_SUMMERY_FAILURE: 'GET_TRANSACTION_SUMMERY_FAILURE',

    //signalR messages
    UPDATE_CONNECTOR_STATUS: 'UPDATE_CONNECTOR_STATUS',
    UPDATE_CHARGER_STATUS: 'UPDATE_CHARGER_STATUS',
    UPDATE_CHARGING_SUMMERY: 'UPDATE_CHARGING_SUMMERY',
    UPDATE_TRANSACTION_DATA: 'UPDATE_TRANSACTION_DATA',

    RESET_STATE_INFO: 'RESET_STATE_INFO',
};

export default connectorActionTypes;